(function () {
  var scheduleTimeZone = 'Europe/Rome';

  function parseSchedule(value, endOfDay) {
    if (!value) return null;
    var match = value.trim().match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (!match) return null;

    return Date.UTC(
      Number(match[1]),
      Number(match[2]) - 1,
      Number(match[3]),
      endOfDay ? 23 : 0,
      endOfDay ? 59 : 0
    );
  }

  function romeTimeNow() {
    var parts = new Intl.DateTimeFormat('en-CA', {
      timeZone: scheduleTimeZone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hourCycle: 'h23'
    }).formatToParts(new Date());
    var values = {};

    parts.forEach(function (part) {
      values[part.type] = part.value;
    });

    return Date.UTC(values.year, Number(values.month) - 1, values.day, values.hour, values.minute);
  }

  function canShow(popup) {
    var now = romeTimeNow();
    var start = parseSchedule(popup.dataset.start, false);
    var end = parseSchedule(popup.dataset.end, true);

    return (!start || now >= start) && (!end || now <= end);
  }

  function wasShown(id) {
    try {
      return sessionStorage.getItem('scheduled-popup-' + id) === 'shown';
    } catch (error) {
      return false;
    }
  }

  function markShown(id) {
    try {
      sessionStorage.setItem('scheduled-popup-' + id, 'shown');
    } catch (error) {
      // The popup can still be used if browser storage is unavailable.
    }
  }

  function init() {
    var root = document.querySelector('[data-scheduled-popups]');
    if (!root) return;

    var isEditor = window.Shopify && window.Shopify.designMode;
    var popups = Array.prototype.slice.call(root.querySelectorAll('[data-scheduled-popup]'));
    var popup = popups.find(function (item) {
      return isEditor ? item.dataset.enabled === 'true' : item.dataset.enabled === 'true' && canShow(item) && !wasShown(item.dataset.popupId);
    });

    if (!popup) return;

    var delay = Math.max(0, Number(popup.dataset.delay || 0)) * 1000;
    window.setTimeout(function () {
      popup.hidden = false;
      popup.setAttribute('aria-hidden', 'false');
      if (!isEditor) markShown(popup.dataset.popupId);

      var closeButton = popup.querySelector('[data-scheduled-popup-close]');
      if (closeButton) closeButton.focus();

      function close() {
        popup.hidden = true;
        popup.setAttribute('aria-hidden', 'true');
        document.removeEventListener('keydown', onKeydown);
      }

      function onKeydown(event) {
        if (event.key === 'Escape') close();
      }

      popup.querySelectorAll('[data-scheduled-popup-close]').forEach(function (element) {
        element.addEventListener('click', close);
      });
      document.addEventListener('keydown', onKeydown);
    }, delay);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}());
